import { inGamecenter, isVkPlay } from '@platform/shared';
import Loader from '@components/Loader';
import Breadcrumbs from '@components/Breadcrumbs';
import ContentBlock from './components/ContentBlock';
import Sidebar from './components/Sidebar';
import { collectArrayByHierarchy } from './utils';
import { PAGE_NAME } from '../../utils/services';

export default {
  name: 'DocumentPage',
  components: {
    ContentBlock,
    Sidebar,
    Loader,
    Breadcrumbs,
  },
  page() {
    return {
      title: this.pageTitle,
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('projectSelection'),
          href: 'index',
        },
        {
          label: this.projectTitle,
        },
      ];
    },
    isGCPage() {
      return !!inGamecenter;
    },
    isSwitch() {
      return this.$route.query.switch === '1';
    },
    isNoMenu() {
      return this.$route.query.nomenu === '1';
    },
    isMGVCPage() {
      return document.domain.endsWith('mgvc.com');
    },
    pageTitle() {
      const separator = isVkPlay ? '|' : '—';

      if (this.documentTitle) {
        return `${this.documentTitle} ${separator} ${PAGE_NAME}`;
      } if (this.projectTitle) {
        return `${this.projectTitle} ${separator} ${PAGE_NAME}`;
      }
      return this.$t(isVkPlay ? 'docTitle.docsVkPlay' : 'docTitle.docs', { page: PAGE_NAME });
    },
    projectTitle() {
      const currentSection = this.sectionsResults
        ?.find(item => item.slug === this.$route.params.projectSlug);

      if (currentSection) {
        console.log('currentSection >', currentSection)
        let parseLocale = this.$i18n.locale.split('_')[0];
        if (parseLocale === 'zh') {
          parseLocale = this.$i18n.locale.split('_')[1].toLowerCase()
        }
        console.log('parseLocale >', parseLocale)
        return currentSection[`title_${parseLocale}`];
      }

      return undefined;
    },
    documentTitle() {
      return this.document.data.title;
    },
    document() {
      return this.$store.getters['docs/getterDocument'];
    },
    contents() {
      return this.$store.getters['docs/getterContents'];
    },
    sections() {
      return this.$store.getters['docs/getterSections'];
    },
    sectionsResults() {
      return this.sections?.data?.results || [];
    },
    contentsResults() {
      // Форматирование массива для создания вложенности с выпадающими списками
      // @TODO реализовать вложенность элементов на бэке
      return collectArrayByHierarchy(this.contents.data?.results, [
        this.$route.params.projectSlug,
        this.$route.params.documentSlug,
      ]);
    },
    isLoading() {
      return this.contents.isLoading;
    },
    isContentUnavailable() {
      return this.$i18n.locale !== 'en_US' && this.$i18n.locale !== 'ru_RU';
    },
    isTermsDocs() {
      return window.location.pathname.indexOf('/terms/') > -1;
    },
  },
  created() {
    this.fetchContents();
    this.fetchSections();
  },
  watch: {
    contentsResults: {
      handler: 'redirectToFirstAvailableDocument',
    },
    '$i18n.locale': {
      handler: 'fetchDataOnLocaleChange',
    },
  },
  methods: {
    fetchDataOnLocaleChange() {
      this.fetchContents();
      this.fetchSections();
    },
    redirectToFirstAvailableDocument() {
      if (!this.$route.params.documentSlug && this.contents?.data) {
        const document = this.contents?.data?.results
          .find(item => item?.documents?.find(doc => doc?.slug));
        const documentSlug = document?.documents[0]?.slug;

        this.$router.replace({
          name: 'document-page',
          params: {
            projectSlug: this.$route.params.projectSlug,
            documentSlug,
          },
        });
      }
    },
    fetchContents() {
      this.$store.dispatch('docs/fetchContents', {
        projectSlug: this.$route.params.projectSlug,
      });
    },
    fetchSections() {
      this.$store.dispatch('docs/fetchSections');
    },
  },
};
